import { Eyebrow } from "@/components/media/Sections";
import { BadgeCheck, Megaphone, Palette, PhoneCall } from "lucide-react";

const ICONS = {
  "lic-brand": BadgeCheck,
  "lic-materials": Palette,
  "lic-social": Megaphone,
  "lic-coaching": PhoneCall,
};

/** One-year brand license included with every operator path. */
export const LicenseBlock = ({ license }) => {
  if (!license) return null;
  return (
    <>
      <Eyebrow>{license.eyebrow}</Eyebrow>
      <h2 className="neon mt-3 max-w-4xl text-4xl leading-tight sm:text-5xl">{license.title}</h2>
      <p className="mt-5 max-w-2xl text-base text-muted-foreground md:text-lg">{license.intro}</p>

      <div className="mt-12 grid gap-5 sm:grid-cols-2">
        {(license.pillars || []).map((p, i) => {
          const Icon = ICONS[p.id] || BadgeCheck;
          return (
            <div
              key={p.id}
              data-testid={`license-pillar-${p.id}`}
              className="group border border-border bg-[#141414] p-6 transition-colors hover:border-primary/60 md:p-8"
            >
              <div className="flex items-center gap-3">
                <Icon size={18} className="text-primary" />
                <span className="mono text-[10px] tracking-widest text-muted-foreground">
                  0{i + 1}
                </span>
              </div>
              <h3 className="display mt-4 text-2xl uppercase leading-none md:text-3xl">
                {p.title}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-muted-foreground">{p.body}</p>
            </div>
          );
        })}
      </div>

      <div
        data-testid="license-renewal"
        className="mt-10 border-l-2 border-primary bg-[#191603] p-6 md:p-8"
      >
        <div className="mono text-[10px] tracking-widest text-primary">
          {(license.renewal_title || "").toUpperCase()}
        </div>
        <p className="mt-3 max-w-2xl text-base text-white">{license.renewal_body}</p>
      </div>

      {license.legal_note ? (
        <p
          data-testid="license-legal-note"
          className="mono mt-8 max-w-3xl text-[10px] leading-relaxed tracking-widest text-muted-foreground"
        >
          {license.legal_note}
        </p>
      ) : null}
    </>
  );
};
